import styled from 'styled-components';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import Image from '../../Image';

export const ImageWrapper = styled.div`
  justify-content: center;
  align-items: center;
`;

export const MainImage = styled(Image)`
  margin: ${spacing(2)} 0;

  height: 200px;

  ${mediaQuery.tabletPortrait`
    margin: ${spacing(3)} 0;
    height: 354px;
  `}

  ${mediaQuery.tabletLandscape`
    margin: 0;
    height: 352px;
  `}
`;
